<template lang="pug">
.multi-step-progress-bar
  .step(v-for="step in totalSteps" :class="{'in-progress': step === currentStep, 'completed': step < currentStep}")
</template>
<script setup lang="ts">
defineProps<{
  currentStep: number,
  totalSteps: number,
}>()
</script>
<style lang="scss" scoped>
$progress-green-color: $color-green-light;
$progress-gray-color: #D8D8D8;

.multi-step-progress-bar {
  display: flex;
  flex-direction: row;
  gap: $space-xxxs;
  margin: $space-m 0;

  .step {
    background-color: $progress-gray-color;
    flex-grow: 1;
    height: $space-xxs;
    position: relative;

    &.in-progress::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 15%;
      background-color: $progress-green-color;
    }

    &.completed {
      background-color: $progress-green-color;
    }
  }
}
</style>
